import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { t } from 'i18next'

import ZDialog from '../../Shared/Dialogs/ZDialog.jsx'

const UserDetail = ({ isOpen, selectedUser, onClose }) => {
  return (
    <ZDialog
      id={'user'}
      isOpen={isOpen}
      title={`${selectedUser?.firstName} ${selectedUser?.lastName}`}
      maxWidth="sm"
      content={
        <>
          <Stack spacing={2} sx={{ mb: 3 }}>
            {selectedUser?.organizations && (
              <>
                <Typography variant="subtitle1">{t('common.organizations')}</Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="user organizations table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">{t('common.organization')}</TableCell>
                        <TableCell align="left">{t('common.role')}</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedUser?.organizations.map((row) => (
                        <TableRow
                          key={row.key}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell
                            id='organizations-table-org-name'
                            component="th"
                            scope="row"
                            align="left"
                          >
                            {row.name}
                          </TableCell>
                          <TableCell id='organizations-table-user-role' align="left">
                            {row.role}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </Stack>
        </>
      }
      onClose={onClose}
    />
  )
}

export default UserDetail
